import { uniqBy } from 'lodash';
import { observable, action, computed, makeObservable } from 'mobx';

import { RacerRace } from '../models';

import { RaceName } from '../types';

export class RacesNamesFilters {
  static racesNamesDefaultParams = {
    search: '',
    searchFields: 'name:like',
    searchJoin: 'AND',
    orderBy: 'id',
    sortedBy: 'asc',
    limit: 20,
    page: 1,
  };

  static relatedRacesParams = {
    search: '',
    searchFields: 'id:=',
    searchJoin: 'AND',
    orderBy: 'id',
    sortedBy: 'asc',
    page: 1,
  };

  @observable
  paginationMeta: PaginationMeta = {};

  @observable
  values: Array<RaceName> = [];

  @observable
  page = 1;

  @observable
  noMoreData = false;

  @observable
  selectionId: number | null = null;

  @observable
  filters: FiltersType = RacesNamesFilters.racesNamesDefaultParams;

  relatedFilters: FiltersType = RacesNamesFilters.relatedRacesParams;

  constructor() {
    makeObservable(this);
  }

  @action
  addPaginationMeta(meta: PaginationMeta) {
    this.paginationMeta = meta;
  }

  @action
  addValues(values: Array<RaceName>, page: number, filters: FiltersType) {
    this.values = values;
    this.page = page;
    this.filters = filters;

    this.noMoreData = !values.length;
  }

  @action
  appendValues(values: Array<RaceName>, page: number, filters: FiltersType) {
    this.values = uniqBy([...this.values, ...values], 'id');
    this.page = page;
    this.filters = filters;

    const { limit = 0 } = this.filters;

    this.noMoreData = values.length < limit;
  }

  @action
  clearAll() {
    this.values = [];
  }

  @action
  clearRelativeSelection() {
    this.selectionId = null;
  }

  getNameById(id: number, values: Array<RaceName>): string {
    const raceName = values.find((el) => {
      return +el.id === +id;
    });

    if (!raceName) {
      return '';
    }

    const race = new RacerRace(raceName);

    return race.value.name;
  }

  @action
  getRaceNameById(id: number): string {
    return this.getNameById(id, this.values);
  }

  @action
  selectRaceId(id: number): void {
    this.selectionId = id;
  }

  @action
  filterRacesById(id: number): Array<RaceName> {
    return this.values.filter((el) => +el.id === id);
  }

  @computed
  get filteredValues(): Array<RaceName> {
    if (this.selectionId) {
      return this.values.filter((el) => +el.id === this.selectionId);
    }

    return this.values;
  }
}

const racesNamesFilters = new RacesNamesFilters();
export { racesNamesFilters };
